import trackClicks from './data_layer';

function orUndefined(value) {
  return value || undefined;
}

function buildEventData(link) {
  const d = link.dataset;
  return {
    event: 'timetable_click',
    activity: orUndefined(d.activity),
    activity_subcategory: orUndefined(d.activitySubcategory),
    venue: orUndefined(d.venue),
    venue_region: orUndefined(d.venueRegion),
    venue_type: orUndefined(d.venueType),
    session_location: orUndefined(d.sessionLocation),
    session_name: orUndefined(d.sessionName),
    session_date: orUndefined(d.sessionDate),
    session_time: orUndefined(d.sessionTime),
    click_text: link.textContent.trim(),
    click_url: link.href,
  };
}

const SELECTOR = '.weekly-timetable__book-btn--book, .weekly-timetable__book-btn--waitlist';

export default function timetableTracking() {
  trackClicks(SELECTOR, buildEventData);
}
